import React from 'react'

import { Step, StepProps } from '@guiker/components-library'

export const ActivateYourAccount: React.FC<StepProps> = (props) => {
  return <Step {...props}>Redirect to 2nd step on load</Step>
}
